var ezdia;
(function (ezdia) {
    function pillTemplateName(context) {
        var value = context.value, lower = context.lower, upper = context.upper, name = context.name, operator = context.operator;
        var ret = "<li>\n      <div class=\"ez-search-advanced-query\" title=\"" + value + " " + lower + " " + upper + "\">\n      " + name + " " + operator + " <b>" + value + " " + lower + " " + upper + "</b>\n      </div>\n    </li> ";
        return ret;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function saveTemplateName(context) {
        var ret = "<div class=\"ez-dialog-action-msg row\" data-container=\"msg\"></div>\n    Please enter a new name for the search: <br><br>\n    <input id= \"save_search_query\" class=\"form-control\" name=\"save_search_query\" maxlength=\"45\" type=\"text\"/>";
        return ret;
    }
    function saveTemplateItem(context) {
        var name = context.name, query = context.query;
        var ret = "<li data-label=\"" + name + "\">\n      <input type=\"hidden\" data-value=\"" + name + "\" value=\"" + query + "\">\n      <a href=\"javascript:void(0);\">" + name + "  <span data-search-advance-item=\"delete\" class=\"fa fa-trash-o\" title=\"Click to delete\"></span></a>\n    </li>";
        return ret;
    }
    function basicSearchClearBtn(id, edittype) {
        var htmlContent = '';
        if (edittype !== 'singlechoice' &&
            edittype !== 'multichoice' &&
            edittype !== 'status') {
            htmlContent = "<button\n        data-search-basic=\"btn\"\n        class=\"btn btn-default btn-sm\"\n        type=\"button\"\n        data-type=\"" + edittype + "\"\n        data-id=\"" + id + "\"\n      >\n        <i class=\"fa fa-close\"></i>\n      </button>";
        }
        return htmlContent;
    }
    function basicSearchFieldsMarkup(column, input) {
        var label = column.label, name = column.name, id = column.id, edittype = column.edittype;
        var ret = "<div class=\"form-group\">\n    <label for=\"" + name + "\">" + label + ": </label>\n    " + input + " " + basicSearchClearBtn(id, edittype) + "\n    </div>";
        return ret;
    }
    function getClearBasicSearchBtn(id) {
        return "<button id=\"" + id + "\" type=\"button\" class=\"clear-basic-search-btn\" disabled>Clear All</button>";
    }
    function getCreateuserBtn() {
        var _a = ezdia.config.pageParams, hasCreateUserRole = _a.hasCreateUserRole, fullUrl = _a.fullUrl;
        var htmlContent = "";
        if (hasCreateUserRole) {
            htmlContent = "<div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-group\">\n            <a class=\"btn btn-success\" href=\"" + fullUrl + "/desk/CreateUserForm.htm\" id=\"createusr\">+ New User</a>\n          </div>\n          <p>&nbsp;</p>\n        </div>\n      </div>";
        }
        return htmlContent;
    }
    function getSysSavedList(sysSavedSearch) {
        var e_1, _a;
        if (!sysSavedSearch || !Object.keys(sysSavedSearch)) {
            return "";
        }
        var htmlContent = [];
        try {
            for (var _b = __values(Object.entries(sysSavedSearch)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), label = _d[0], value = _d[1];
                htmlContent.push("<li data-label=\"" + label + "\">\n        <input type=\"hidden\" data-value=\"" + label + "\" value='" + value + "'/>\n        <a href=\"javascript:void(0);\">" + label + "</a>\n      </li>");
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return "<ul class=\"list-unstyled\" role=\"menu\" data-search=\"system\">\n      " + htmlContent.join('') + "\n    </ul>";
    }
    function getUserSavedList(userSavedSearch) {
        var e_2, _a;
        if (!userSavedSearch || !userSavedSearch.length) {
            return "";
        }
        var htmlContent = [];
        try {
            for (var userSavedSearch_1 = __values(userSavedSearch), userSavedSearch_1_1 = userSavedSearch_1.next(); !userSavedSearch_1_1.done; userSavedSearch_1_1 = userSavedSearch_1.next()) {
                var query = userSavedSearch_1_1.value;
                var name_1 = query.name;
                htmlContent.push("<li data-label=\"" + name_1 + "\">\n        <input type=\"hidden\" data-value=\"" + name_1 + "\" value='" + JSON.stringify(query) + "'/>\n        <a href=\"javascript:void(0);\">" + name_1 + "<span data-search-advance-item=\"delete\" class=\"fa fa-trash-o\" title=\"Click to delete\"></span></a>\n      </li>");
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (userSavedSearch_1_1 && !userSavedSearch_1_1.done && (_a = userSavedSearch_1.return)) _a.call(userSavedSearch_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return "<ul class=\"list-unstyled\" role=\"menu\" data-search=\"user\">\n      <li class=\"heading\">User Saved Search</li>\n      " + htmlContent.join('') + "\n    </ul>";
    }
    function getSavedSearchList() {
        var _a = ezdia.config.pageParams, sysSavedSearch = _a.sysSavedSearch, userSavedSearch = _a.userSavedSearch, isMyOpenTask = _a.isMyOpenTask, isCustomSearch = _a.isCustomSearch;
        if (isMyOpenTask) {
            return "";
        }
        var htmlContent = "<button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\"   data-search-advance-dropdown-btn=\"button\"><i class=\"fa fa-sliders fa-rotate-90\"></i> Filters: <b data-search-advance-selected=\"label\">No filters applied</b> <span class=\"caret\"></span></button>\n    <div id=\"sys-advanced-search-menu\" class=\"dropdown-menu ez-advanced-search-menu\" data-search-advance=\"menu\">\n      <div class=\"ez-advanced-search-menu-header\">\n        <input type=\"text\" class=\"ez-form-control\" data-search-advance=\"search input\"  placeholder=\"Search in list...\">\n      </div>\n      <div class=\"ez-advanced-search-menu-body\" data-search-container=\"body\">\n        " + getSysSavedList(sysSavedSearch) + getUserSavedList(userSavedSearch) + "\n      </div>\n      <div class=\"ez-advanced-search-menu-footer clearfix\">\n        " + (isCustomSearch
            ? "<div>\n          <a class=\"btn btn-default btn-sm\" data-search=\"custom\" data-label=\"Custom search\" href=\"javascript:void(0);\" title=\"Create new Custom search\">Custom search </a>\n        </div>"
            : '') + "\n        <div class=\"rearrange\">\n          <a class=\"btn btn-default btn-sm\" data-search=\"rearrange\" href=\"javascript:void(0);\" title=\"Rearrange user saved searchs.\">Reorder</a>\n        </div>\n      </div>\n    </div>";
        return "<div class=\"btn-group\">" + htmlContent + "</div>";
    }
    function getSaveSearchtBtn() {
        var hasUserSearch = ezdia.config.pageParams.hasUserSearch;
        var htmlContent = "";
        if (hasUserSearch) {
            htmlContent = "<input type=\"button\" class=\"btn btn-default btn-sm\" value=\"Save Search\" data-search-advance=\"save search\" id=\"saveSearchQueryBtn\"/>";
        }
        return htmlContent;
    }
    function getExportBtn() {
        var _a = ezdia.config.pageParams, isMyOpenTask = _a.isMyOpenTask, exportRole = _a.exportRole, formType = _a.formType;
        var htmlContent = '';
        if ((!isMyOpenTask && formType === 'desk' && exportRole) ||
            formType === 'negative_filter' ||
            (formType === 'paymanager' && exportRole)) {
            htmlContent = "<input value=\"Export\" type=\"button\" data-search-advance=\"export\" class=\"btn btn-default btn-sm\"/>";
        }
        return htmlContent;
    }
    function basicHtmlContent() {
        var _a = ezdia.config.pageParams, formType = _a.formType, tab = _a.tab;
        return "<form id=\"searchFrm\" class=\"form-inline search-button-group-form\" method=\"POST\" style=\"margin: 0\">\n      <input type=\"hidden\" value=\"" + formType + "\" name=\"formType\" id=\"pageTemplateName\"/>\n      " + getCreateuserBtn() + "\n      <div class=\"ez-search-qaaction-wrapper\">\n        <div>\n        " + getSavedSearchList() + "\n        </div>\n        <div id=\"sys-basic-search-query-display-wrap\" data-search-basic=\"container\" class=\"basic-search-rows\">\n        </div>\n\n        <div data-search-advance=\"container\" class=\"ez-advanced-search\">\n          <div class=\"ez-advanced-search-querys\">\n            <p data-search-advance=\"query and or any\">Items matching\n              <select id=\"srchOperand\" name=\"srchOperand\" class=\"form-control input-sm\">\n                <option value=\"and\">All</option>\n                <option value=\"or\">Any</option>\n              </select> of the following:\n            </p>\n            <div data-search-advance=\"query\" class=\"clearfix\"></div>\n          </div>    \n          <div data-search-advance=\"button\" class=\"ez-advanced-search-btns\" style=\"display: none\">\n            <p></p>\n            <input type=\"button\" class=\"btn btn-primary btn-sm\" value=\"Search\" data-search-advance=\"search\"/>\n            " + getSaveSearchtBtn() + "\n            <input type=\"hidden\" id=\"tabVal\" value=\"" + tab + "\"/>\n            " + getExportBtn() + "\n            <a href=\"javascript:void(0)\" class=\"btn btn-link btn-sm\" data-search-advance=\"clear\">Clear</a>\n            <a href=\"javascript:void(0)\" class=\"btn-circle-icon btn-default pull-right min\" data-search-advance=\"min\" title=\"Click to minimize\"><i class=\"fa fa-chevron-up\"></i></a>\n          </div>\n        </div>\n      </div>\n\n    </form>";
    }
    var templates;
    (function (templates) {
        templates.serach = {
            basicHtmlContent: basicHtmlContent,
            pillTemplateName: pillTemplateName,
            saveTemplateName: saveTemplateName,
            saveTemplateItem: saveTemplateItem,
            basicSearchFieldsMarkup: basicSearchFieldsMarkup,
            getClearBasicSearchBtn: getClearBasicSearchBtn
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
